<template>
  <v-container pa-0 fill-height>
    <v-btn v-if="id != ''" text small @click="onClick">
      <v-icon left small>mdi-format-list-bulleted-square</v-icon>
      {{ label }}
      <v-icon small right button @click.stop="onNewTab($event)"
        >mdi-open-in-new</v-icon
      >
    </v-btn>
    <span v-else>
      {{ label }}
    </span>
  </v-container>
</template>

<script>
export default {
  name: "reference-label",
  props: {
    value: {
      type: String,
      defaule: () => "Reference",
    },
    itineraryId: {
      type: String,
      default: () => "",
    },
    newTab: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    id() {
      return this.params
        ? this.params.data.itinerary
          ? this.params.data.itinerary.id
          : this.params.data.id
        : this.itineraryId;
    },
    label() {
      return this.params
        ? this.params.value.split("/")[2]
        : this.value
        ? this.value.split("/")[2]
        : "";
    },
  },
  methods: {
    onNewTab(e) {
      e.preventDefault();
      window.open(`/itinerary/${this.id}/details`, "_blank");
    },
    onClick() {
      if (this.newTab) {
        window.open(`/itinerary/${this.id}/details`, "_blank");
      } else {
        this.$router.push(`/itinerary/${this.id}/details`);
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/ReferenceLabel.vue